import {Page, LeftSidebar, Content, RightSidebar} from '../layout/index.styled';
import {StudentDetail as StudentDetailUI, useStudentDetail, StudentDetailContext} from '@esgi/main/features/teacher/student-detail';
import {Activities} from '@esgi/main/kits/activities';
import {Reports, ExpandablePanel} from '@esgi/main/kits/reports';
import {Wrapper, Header, Divider} from './index.styled';
import {useStream, useBehaviorSubject} from '@esgi/ui';
import {withNewOldReports} from '../old-reports';
import {OldStudentsDetail} from '../old-reports/students/students-detail';

function StudentDetail() {
	const {service} = useStudentDetail();
	const valid = useStream(service.valid$, false);
	const busy = useStream(service.busy$, false);
	const classes = useBehaviorSubject(service.studentService.classes$);
	const groups = useBehaviorSubject(service.studentService.groups$);
	const studentList = useBehaviorSubject(service.studentService.students$);
	const loadedStudents = useBehaviorSubject(service.studentService.loaded$);
	const subjects = useBehaviorSubject(service.subjectService.subjects$);
	const loadedSubjects = useBehaviorSubject(service.subjectService.loaded$);
	const grades = useBehaviorSubject(service.grades$);
	const subject = useBehaviorSubject(service.subject$);
	const students = useBehaviorSubject(service.students$);
	const tests = useBehaviorSubject(service.testService.tests$);
	const loadingTests = useBehaviorSubject(service.testService.loading$);
	const settings = useBehaviorSubject(service.settings$);
	const grade = useBehaviorSubject(service.grade$);
	const markingPeriod = useBehaviorSubject(service.markingPeriod$);
	const notTested = useBehaviorSubject(service.notTested$);
	const preview = useBehaviorSubject(service.preview$);

	return (
		<StudentDetailContext.Provider value={service}>
			<Page>
				<LeftSidebar>
					<Activities.StudentsControl
						skeleton={!loadedStudents}
						classes={classes}
						groups={groups}
						students={studentList}
						onChange={(value) => service.setStudents(value)}
					/>
				</LeftSidebar>
				<Content>
					<Header>
						<Reports.StudentPanel
							studentCounter={students.length}
							student={service.studentService.get(students.length && students[0].studentId)}
						/>
						<Divider/>
						<Reports.SubjectControl
							skeleton={!loadedSubjects}
							subjects={subjects}
							value={subject.toString()}
							onChange={(value) => service.setSubject(+value)}
						/>
					</Header>
					{students.length
						?
							<Reports.TestsControl
								skeleton={loadingTests}
								tests={tests}
								onChange={(value) => service.setTests(value)}
							/>
						: <Reports.NoStudentPanel/>
					}
				</Content>
				<RightSidebar>
					<Reports.ReportPanel
						reportTitle='Report'
						disabled={busy || !valid}
						onReport={() => service.onPreview(() => service.setPreview(true))}
					/>
					<ExpandablePanel>
						<Wrapper>
							<StudentDetailUI.SettingsControl
								value={settings}
								onChange={(value) => service.setSettings(value)}
							/>
							<StudentDetailUI.GradesControl
								grades={grades}
								disabled={!grades.length}
								value={grade}
								onChange={(value) => service.setGrade(value)}
							/>
							<StudentDetailUI.MarkingPeriodControl
								value={markingPeriod}
								onChange={(value) => service.setMarkingPeriod(value)}
							/>
							<StudentDetailUI.NotTestedControl
								value={notTested}
								onChange={(value) => service.setNotTested(value)}
							/>
						</Wrapper>
					</ExpandablePanel>
				</RightSidebar>
			</Page>
			{preview &&
				<StudentDetailUI.PreviewDialog
					onClose={() => service.setPreview(false)}
					onDownload={(fileType) => service.onDownload(fileType)}
				/>
			}
		</StudentDetailContext.Provider>
	);
}

export default withNewOldReports(OldStudentsDetail, StudentDetail);
